import { Required, IsString, DataValidator } from "@/utils/type-vaildator";
import api from "./api";

// 口播台词发音修改标记数据类型
export type ScriptReplaceMark = {
  type: "replace";
  indexRange: [number, number];
  text: string;
};

export interface GenerateMessageRequest {
  agentId: string;
  text: string;
  type: 1 | 2 | 3 | 4 | 5;
  templateId?: number;
  voiceId?: string;
  taskId?: string;
  linkUrl?: string;
  noteId?: number;
  templateResource?: number;
  outLang?: string;
  typeScene?: string;
  marks?: ScriptReplaceMark[];
  point?: number;
  resultVideoDuration?: number;
}

class MakeGenerateResponseRaw {
  @Required("task_id 不能为空")
  @IsString("task_id 必须是字符串")
  task_id: string;
}

export const generateMessage = async ({
  taskId,
  agentId,
  text,
  type,
  templateId,
  voiceId,
  linkUrl,
  noteId,
  templateResource,
  outLang,
  typeScene,
  marks,
  point,
  resultVideoDuration,
}: GenerateMessageRequest): Promise<string> => {
  // if (!agentId) throw new Error("agentId 不能为空");
  if (!text && !text.trim() && !noteId && !linkUrl) throw new Error("text 或 noteId 或 linkUrl 不能为空");
  if (![1, 2, 3, 4, 5].includes(type)) throw new Error("type 必须是 1..5 的整数");

  const templateIdInt = typeof templateId !== "number" ? parseInt(templateId, 10) : templateId;
  const payload: Record<string, any> = {
    agent_id: agentId,
    text,
    type,
    task_id: taskId,
  };
  if (!Number.isNaN(templateIdInt!) && templateIdInt !== undefined) payload.template_id = templateIdInt;
  if (voiceId) payload.audio_id = voiceId;
  if (linkUrl) payload.link_url = linkUrl;
  if (noteId) payload.note_id = noteId;
  if (templateResource) payload.template_resource = templateResource;
  if (outLang) payload.out_lang = outLang;
  if (typeScene) payload.type_scene = typeScene;
  if (marks && marks.length) payload.marks = marks;
  if (point) payload.point = Number(point);
  if (resultVideoDuration) payload.result_video_duration = Number(resultVideoDuration);

  const res = await api.post<MakeGenerateResponseRaw>("/make/generate", payload);
  const root = res.data as any;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.task_id;
};
